/**
 * Commerce7 Product Details
 */

import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
    const selectors = {};

    this.init = () => {
        c7.addAction("c7_product_detail_rendered", (content) => {
            // Do something after product detail rendered.
            formatPrice()
            renderBg()
            getBundleItems()
        });
        const getBundleItems = () => {
            const isBundle = jQuery(".product-detail-page--Bundle");
            if (isBundle.length == 0 || !isBundle) {
                return;
            }
            let slugArr = location.pathname.split("/").slice(1);
            if (slugArr.length) {
                let slug = slugArr[1];
                jQuery.ajax({
                    type: "GET",
                    dataType: "json",
                    url: theme_object.ajax_url,
                    data: {
                        action: "get_bundle_items",
                        slug: slug,
                    },
                    context: this,
                    beforeSend: function () { },
                    success: function (response) {
                        if (response.success) {
                            const titleProduct = jQuery(
                                ".c7-product__details .c7-product__title"
                            ).text();
                            // jQuery(".bundle-list-line").html(response.content.bundle_line);
                            jQuery(".bundle-list-cards-wrapper").append(
                                `<h2 class="title-section">A look into ${titleProduct}</h2>`
                            );
                            jQuery(".bundle-list-cards-wrapper").append(
                                response.content.bundle_card
                            );
                            response.content.bundle_items.forEach((item) => {
                                jQuery(".bundle-item").append(
                                    `<h3>${item.productTitle}</h3>`
                                );
                            });
                            c7.doAction("c7_product_bundle_collections_rendered");
                        }
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log(
                            "The following error occured: " + textStatus,
                            errorThrown
                        );
                    },
                });
            }
        };
        const formatPrice = () => {
            jQuery(
                ".c7-product__add-to-cart__price span.c7-sr-only + span,.c7-product__add-to-cart__price .c7-price--discounted"
            ).each(function (i, e) {
                let text = jQuery(e).text();
                jQuery(e).text(
                    text.replace("$", "").replace(".00", "").replace("Was", "").replace("Now", "")
                );
                jQuery(e).prepend(`<span class="currency">$</span>`)
            });
            jQuery(
                ".c7-product__add-to-cart__price"
            ).css("display", "flex")
        }
        const renderBg = () => {
            if ("null" === bgBottle || "undefined" === typeof bgBottle || jQuery('.product-detail-page .c7-product__image').hasClass('true')) {
                return;
            }
            jQuery('.product-detail-page .c7-product__image').css('background-image', 'url(' + bgBottle + ')');
        }
    };
}
